/* PB Before & After — thumb switching + draggable split handle
   Source parity: .pure-brolic-html/script.js beforeAfter block
*/
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.pbInit === '1') return;
    root.dataset.pbInit = '1';

    var thumbs = root.querySelectorAll('.pb-ba__thumb');
    var befores = root.querySelectorAll('.pb-ba__before');
    var afters = root.querySelectorAll('.pb-ba__after');
    var panels = root.querySelectorAll('.pb-ba__panel');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var key = thumb.getAttribute('data-product');
        thumbs.forEach(function (t) { t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-selected', 'true');
        befores.forEach(function (img) { img.classList.toggle('is-active', img.getAttribute('data-product') === key); });
        afters.forEach(function (img) { img.classList.toggle('is-active', img.getAttribute('data-product') === key); });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-product') === key); });
      });
    });

    var inner = root.querySelector('[data-pb-ba-inner]');
    var handle = root.querySelector('[data-pb-ba-handle]');
    if (!inner || !handle) return;

    var dragging = false;

    function setSplit(clientX) {
      var rect = inner.getBoundingClientRect();
      var x = clientX - rect.left;
      var pct = (x / rect.width) * 100;
      if (pct < 4) pct = 4;
      if (pct > 96) pct = 96;
      inner.style.setProperty('--ba-split', pct + '%');
    }

    function onDown(e) {
      dragging = true;
      inner.classList.add('is-dragging');
      if (handle.setPointerCapture && e.pointerId !== undefined) {
        try { handle.setPointerCapture(e.pointerId); } catch (_) {}
      }
      setSplit(e.clientX);
      e.preventDefault();
    }
    function onMove(e) { if (dragging) setSplit(e.clientX); }
    function onUp() { dragging = false; inner.classList.remove('is-dragging'); }

    handle.addEventListener('pointerdown', onDown);
    window.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', onUp);
    window.addEventListener('pointercancel', onUp);

    inner.addEventListener('pointerdown', function (e) {
      if (e.target === handle || handle.contains(e.target)) return;
      setSplit(e.clientX);
    });
  }

  function initAll() { document.querySelectorAll('.pb-ba').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.pb-ba');
    if (root) init(root);
  });
})();
